<!--
    Page: Group Renewal Landing
	Author: Sunny Khatri & Pooja Rajput 
    Date: 10-08-2021
-->

<div class="container-fluid view-member-landing pad-l-r-0">
    <!-- Desktop View -->
    <div class="col-lg-12 col-md-12 col-sm-12 d-none d-md-flex renewal-level-main" [formGroup]="form">

        <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12 renewal-level-left-section pad-l-0">
            <h1 class="select-policy-txt">Please proceed by clicking on Pay Premium
                <!-- <span *ngIf="selectedPolicyDetails.ProductName != 'Group Activ Secure'">alter</span> -->
                <!-- <span>renew</span> -->
            </h1>

            <!-- <div class="select-policy-sub-txt">Once
                selected, you can change further details on the right hand side</div> -->
            <div class="active-secure-block col-lg-12 col-md-12 col-sm-12 p-0" *ngFor="let policy of policyDetails">
                <div class="active-secure-heading">
                    <div class="active-secure-head-big-text">
                        {{policy.ProductName}}
                        <label class="active-secure-head-small-text">
                            {{policy.Certificate_number}}
                        </label>
                    </div>
                    <!-- <div class="checkbox-action-block policy-main-land-label policy-selection-checkbox">
                        <input type="radio" class="policy-CheckBox" ([ngModel])="policySelected"
                            value="{{policy.PolicyNumber}}" id="myCheckbox{{$index}}" />
                        
                        <label for="myCheckbox{{$index}}"></label>
                    </div> -->
                </div>
                <div class="active-secure-body col-lg-12 col-md-12 col-sm-12" style="display: flex;">
                    <div class="col-lg-4 col-md-4 col-sm-4 p-0">
                        <div class="active-secure-title">Proposer Name </div>
                        <div class="active-secure-data mb-6">{{policy.NameOfTheProposer}}</div>
                        <div class="active-secure-title">Policy Start-End Date</div>
                        <div class="active-secure-data">{{policy.PolicyStartDate}} - {{policy.PolicyExpiryDate}}</div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 p-0">
                        <div class="active-secure-title">Members</div>
                        <div *ngFor="let member of policy.Members" class="active-secure-data mb-1">{{member.Name}}</div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 p-0">
                        <div class="active-secure-title">Master Policy Number</div>
                        <div>
                            <label class="active-secure-data">
                                {{policy.MasterPolicyNumber}}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="active-secure-footer col-lg-12 col-md-12 col-sm-12" style="display: flex;">
                    <div class="col-lg-4 col-md-4 col-sm-4 p-0">
                        <div class="active-secure-data">Renewal on existing SI</div>
                        <!-- <div class="active-secure-data mb-6"
                            *ngIf="policy.SumInsuredType == 'Individual' || policy.SumInsuredType == 'Family Floater'">
                            <i class="fa fa-rupee rupee_icon"></i> {{policy.Members[0].SumInsured | INR}}
                        </div> -->

                    </div>
                    <div [hidden]="!(policy.Members[0].CB > 0)" class="col-lg-4 col-md-4 col-sm-4 p-0">
                        <div class="active-secure-title">NCB Amount </div>
                        <div class="active-secure-data mb-6"><i class="fa fa-rupee rupee_icon"></i>
                            {{policy.Members[0].CB | INR}}</div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 p-0">
                        <div class="active-secure-title">Premium Amount </div>
                        <div class="active-secure-data mb-6"><i class="fa fa-rupee rupee_icon"></i>
                            {{policy.RenewalGrossPremium | INR}}</div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 p-0">
                    </div>
                </div>
            </div>

            <div class="active-secure-block col-lg-12 col-md-12 col-sm-12 p-0" [formGroup]="form" [hidden]="showDetail">
                <div class="active-secure-heading">
                    <div class="active-secure-head-big-text">
                        Proposer Details
                    </div>
                </div>
                <div class="active-secure-body row" style="display: flex; padding: 10px 30px;">
                    <div class="col-lg-4  col-md-4 p-0 ">
                        <label class="active-secure-label">Proposer Email Address <span
                                class="any-two-red-clr">*</span></label>
                    </div>
                    <div class="col-lg-8 col-md-8  p-0 ">
                        <input type="text" class="form-control textbox-style input-text-style"
                            formControlName="emailAddress" [(ngModel)]="emailAddress"
                            placeholder="Proposer Email Address">
                    </div>
                </div>
                <div class="active-secure-body row" style="display: flex; padding: 10px 30px;">
                    <div class="col-lg-4  col-md-4 p-0 ">
                        <label class="active-secure-label">Proposer Mobile Number <span
                                class="any-two-red-clr">*</span></label>
                    </div>
                    <div class="col-lg-8 col-md-8  p-0 ">
                        <input type="text" class="form-control textbox-style input-text-style" minlength="10"
                            formControlName="mobileNumber" [(ngModel)]="mobileNumber" maxlength="10" appNumberOnly
                            placeholder="Proposer Mobile Number">
                    </div>
                </div>
            </div>

            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 policy-tenure-bg" [formGroup]="form" [hidden]="Ewflag">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pad-l-r-0 white-bg-box">
                    <label style="left: 0;" class="container-new">Use Health Returns of <span
                            class="checkbox-pink-txt">₹ {{HRAmount}}</span>
                        <input type="checkbox" formControlName="isActive" [(ngModel)]="isActive" [checked]="isActive"
                            (change)="updateSumInsured(isActive)" name="healthreturn">
                        <span class="checkmark"></span>
                    </label>
                </div>
                <div class="row pad-l-r-0">
                    <div class="col-lg-6 col-md-12 downloadNotice-ui-b">
                        <a href="javascript:void(0);" class="btn download-renewal-notice-btn "
                            (click)="DownloadRenewalNotice()">
                            Download Notice
                        </a>
                    </div>
                    <div class="col-lg-6 col-md-12 downloadNotice-ui-t">
                        <a href="javascript:void(0);" class="btn pay-premium-button pay-premium-btn"
                            (click)="selectPaymentMode()">
                            Pay Premium <span>₹
                                {{totalPreminum | INR}} </span><img src="assets/images/new-renew/right-white-arrow.svg">
                        </a>
                    </div>
                </div>
            </div>
            <div class="row pad-l-r-0" [hidden]="!Ewflag">
                <div class="col-lg-6 col-md-12 downloadNotice-ui-b">
                    <a href="javascript:void(0);" class="btn download-renewal-notice-btn "
                        (click)="DownloadRenewalNotice()">
                        Download Notice
                    </a>
                </div>
                <div class="col-lg-6 col-md-12 downloadNotice-ui-t">
                    <a href="javascript:void(0);" class="btn pay-premium-button pay-premium-btn"
                        (click)="selectPaymentMode()">
                        Pay Premium <span>₹
                            {{totalPreminum | INR}} </span><img style="float: right; margin-left: 15px;"
                            src="assets/images/new-renew/right-white-arrow.svg">
                    </a>
                </div>
            </div>

        </div>
    </div>
    <!-- End of Desktop View -->

    <!------------------------------ Select Payment Mode Modal ---------------------------------->
    <div class="modal fade" [formGroup]="form" [hidden]="!showPaymentModeModal" [ngClass]="{'in': showHealthMiModal }" style="z-index: 9999 !important;">
        <div class="modal-dialog remove-user-modal">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pad-l-r-0 modal-content">
                <button type="button" class="close close-grey-bg"
                    (click)="showPaymentModeModal = false">&times;</button>
                <!-- <div class="are-you-sure-ttl">
                    Select Payement Mode
                </div> -->
                <div class=" col-lg-10 col-xs-12 pad-l-r-0 pad-top-bot-model">
                    <div>
                        <ng-container *ngIf="!showHideAutoDebitOption">
                            <label class="radio-btn tenure-radio">
                                <span class="lbl-txt">Pay Now via Juspay Emandate</span>
                                <span class="custom-popover large-tooltip usingCC" placement="bottom"
                                    ngbPopover="Pay premium via Juspay Emandate." [triggers]="'mouseenter:mouseleave'">
                                    <img class="img-responsive question-tooltip-img" src="assets/images/tooltip.png">
    
                                </span>
                                <input type="radio" formControlName="pgPaymentMode" value="JP_ emandate">
                                <span class="checkmark"></span>
                            </label>
                            <br>
                            <label class="radio-btn tenure-radio">
                                <span class="lbl-txt">Pay Now via Juspay Enach</span>
                                <input type="radio" formControlName="pgPaymentMode" value="JP_Enach">
                                <span class="checkmark"></span>
                                <span class="custom-popover large-tooltip" placement="bottom" [ngbPopover]="popContent" [triggers]="'mouseenter:mouseleave'">
                                    <img class="img-responsive question-tooltip-img" src="assets/images/tooltip.png">
                                    <ng-template #popContent style="top:89px; left:13px;"
                                        popoverClass="custom-tooltip-text">On selecting 'Pay Now via Debit Card or Net
                                        Banking and Enrol on Auto Debit Mode for Future Premiums' the mentioned premium
                                        amount will be auto-debited from your bank account via Debit Card or Net Banking at
                                        the time of policy renewal. You need to complete an onetime transaction
                                        authorization after which all subsequent payments will not require any intervention.
                                        <br>
                                         Enter Your Bank Details To Verify.
                                        <br>
                                        Make The Payment"
                                    </ng-template>
                                </span>
                            </label>
                            <br>
                        </ng-container>
                        <!--<label class="radio-btn tenure-radio">
                            <span class="lbl-txt">Pay Now via Juspay Enach </span>
                            <span class="custom-popover large-tooltip usingCC" placement="bottom"
                                ngbPopover=" Pay premium via Juspay Enach.">
                                <img class="img-responsive question-tooltip-img" src="assets/images/tooltip.png">

                            </span>
                            <input type="radio" formControlName="pgPaymentMode" value="JP_Enach">
                            <span class="checkmark"></span>
                        </label><br>     -->
                        <label class="radio-btn tenure-radio">
                            <span class="lbl-txt">Skip to normal payment option  </span>
                            <span class="custom-popover large-tooltip usingCC" placement="bottom"
                                ngbPopover="Pay premium manually every year at the time of renewal." [triggers]="'mouseenter:mouseleave'">
                                <img class="img-responsive question-tooltip-img" src="assets/images/tooltip.png">

                            </span>
                            <input type="radio" formControlName="pgPaymentMode" value="JP_normal">
                            <span class="checkmark"></span>
                        </label>
                        
                        <!-- <label ng-show="showThirdTenureVal" class="radio-btn tenure-radio">
                        <span class="lbl-txt">Standing Instructions on credit card</span>
                        <input name="pgPaymentMode" type="radio" formControlName="pgPaymentMode"  [(ngModel)]="pgPaymentMode" value="cards">
                        <span class="checkmark"></span>
                    </label> -->
                    </div>
                </div>
                <div> 
                    <label class="cust-check" style="margin-bottom: 0px;">
                        <input class="radio-btn" type="checkbox"  name="ideclear" formControlName="Ideclear" style="margin-bottom: 0px; margin-left: 5px; margin-right: 10px;">
                        <!-- <span class="checkmark"></span> -->
                        </label>
                            I hereby declare <a style="color:#c7222a; cursor: pointer;" (click)="declareM = true" *ngIf="!declareM">read more</a> <span *ngIf="declareM">that the premium paid under this transaction is being paid by me to cover me and/or my
                            family through a bank account or a Credit / Debit card registered in his / her name or through a prepaid
                            payment instrument (wallet) held by me in their name and it is not a third-party payment made by any
                            other person.</span><a style="color:#c7222a; cursor: pointer;" (click)="declareM = false" *ngIf="declareM">read less</a>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pad-l-r-0">
                    <a href="javascript:void(0);" class="btn cancel-red-bdr-btn" [ngClass]="{'disabled': !form.get('Ideclear')?.value}" 
  (click)="form.get('Ideclear')?.value && requestPgURL()">Proceed To
                        Payment</a>
                </div>
            </div>
        </div>
    </div>
    <!------------------------------ End of Select Payment Mode Modal ---------------------------------->

    <!--------------------------------View member detail-------------------------------------------->
    <!-- <div class="modal fade" [formGroup]="form" [style.display]="viewMember ? 'block' : 'none'"   [ngClass]="{'in': showHealthMiModal }">
        <div class="modal-dialog remove-user-modal">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pad-l-r-0 modal-content">
                   
                        <ul class="member-detail-ul" [style.display]="viewMember ? 'block' : 'none'" >
                        <li class="large-tooltip-li"*ngFor="let member of insuredMembers">{{member.Name}}</li>
                         <span   class="pop-close member-detail-close" (click)="viewMembers('pop-close');">×</span>
                        </ul>
                    
            </div>
        </div>
    </div> -->

    <!----------------------------------view member detail end-------------------------------------->

    <!-- Mobile View -->
    <div class="col-xs-12 col-xs-12 d-flex d-md-none new-renewal-landing-mobile ">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 page-padding grey-page-background card-page">
            <div class="header-ttl">Select Which Policy to <span>Renew</span>

            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pad-l-r-0 ">
                <div class="accordion  pointerCursor renewal-level-main" id="accordionExample">
                    <ngb-accordion #acc="ngbAccordion" [closeOthers]="true" activeIds="static-0"
                        class="active-secure-block active-secure-heading">
                        <ngb-panel class="active-secure-head-big-text pull-left "
                            *ngFor="let policy of policyDetails; let i = index" id="{{'static-' + i}}"
                            title="{{policy.ProductName}} - {{policy.Certificate_number}}">
                            <div class="active-secure-title">Premium Amount </div>
                            <!-- <div class="active-secure-data mb-6"><i class="fa fa-rupee rupee_icon"></i>₹
                            {{policy.UpdatedGrossPremium | INR}}</div> -->
                            <ng-template ngbPanelContent>
                                <div class="active-secure-body">
                                    <div class="col-lg-12 col-md-12 col-sm-12 p-0">
                                        <div class="d-flex justify-content-between">
                                            <div class="active-secure-title">Proposer Name </div>
                                            <div class="active-secure-data mb-6">{{policy.NameOfTheProposer}}</div>
                                        </div>
                                        <div class="d-flex justify-content-between">
                                            <div class="active-secure-title">Policy Date</div>
                                            <div class="active-secure-data">{{policy.PolicyStartDate}} -
                                                {{policy.PolicyExpiryDate}}</div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 p-0">
                                        <div class="d-flex justify-content-between">
                                            <div class="active-secure-title">Members</div>
                                            <!-- <div *ngFor="let member of insuredMembers" class="active-secure-data mb-1">{{member.Name}}</div> -->
                                            <div class="active-secure-data view-member-detail mb-1"
                                                (click)="viewMembers('custom-popover');">View Member details
                                            </div>
                                            <div class="modal fade" [formGroup]="form"
                                                [ngClass]="{'in': showHealthMiModal }"
                                                [style.display]="viewMember ? 'block' : 'none'">
                                                <div class="modal-dialog remove-user-modal">
                                                    <div
                                                        class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pad-l-r-0 modal-content view-user-detail-popup">
                                                        <ul class="member-detail-ul"
                                                            *ngFor="let member of policy.Members">
                                                            <li class="large-tooltip-li">{{member.Name}}
                                                            </li>
                                                            <span class="pop-close member-detail-close"
                                                                (click)="viewMembers('pop-close');">×</span>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <div class="custom-popover large-tooltip" >
                                       <ul class="custom-tooltip-text" [style.display]="viewMember ? 'block' : 'none'" >
                                       <li class="large-tooltip-li"*ngFor="let member of insuredMembers">{{member.Name}}</li>
                                        <span   class="pop-close" (click)="viewMembers('pop-close');">×</span>
                                       </ul>
                                    </div> -->
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 p-0">
                                        <div class="d-flex justify-content-between">
                                            <div class="active-secure-title">Master Policy Number</div>
                                            <div>
                                                <label class="active-secure-data">
                                                    {{policy.MasterPolicyNumber}}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="active-secure-footer ">
                                    <div class="col-lg-12 col-md-12 col-sm-12 p-0 d-flex justify-content-between">
                                        <div class="active-secure-data">Renewal on existing SI</div>
                                        <!-- <div class="active-secure-data mb-6"
                                            *ngIf="policy.SumInsuredType == 'Individual' || policy.SumInsuredType == 'Family Floater'">
                                            <i class="fa fa-rupee rupee_icon"></i>{{policy.Members[0].SumInsured |
                                            INR}}
                                        </div> -->

                                    </div>
                                    <div [hidden]="!(policy.Members[0].CB > 0)"
                                        class="col-lg-12 col-md-12 col-sm-12 p-0">
                                        <div class="active-secure-title">NCB Amount </div>
                                        <div class="active-secure-data mb-6"><i class="fa fa-rupee rupee_icon"></i> ₹
                                            {{policy.Members[0].CB | INR}}</div>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 p-0 d-flex justify-content-between">
                                        <div class="active-secure-title">Premium Amount </div>
                                        <div class="active-secure-data mb-6"><i class="fa fa-rupee rupee_icon"></i>
                                            {{policy.RenewalGrossPremium | INR}}</div>
                                    </div>
                                    <!-- <div class="col-lg-4 col-md-4 col-sm-4 p-0">
                        </div> -->
                                </div>
                            </ng-template>

                        </ngb-panel>

                    </ngb-accordion>
                    <ngb-accordion #acc="ngbAccordion" [closeOthers]="true" activeIds="static-0"
                        class="active-secure-block active-secure-heading" [hidden]="showDetail" [formGroup]="form">
                        <ngb-panel class="active-secure-head-big-text pull-left " title="Proposer Detail" id="static-0">
                            <!-- <div class="active-secure-title">Premium Amount </div> -->
                            <!-- <div class="active-secure-data mb-6"><i class="fa fa-rupee rupee_icon"></i>₹
                            {{policy.UpdatedGrossPremium | INR}}</div> -->
                            <ng-template ngbPanelContent>
                                <div class="active-secure-body">
                                    <div class="col-lg-12 col-md-12 col-sm-12 p-0">
                                        <div class="active-secure-body row">
                                            <div class="col-lg-4  col-md-12 p-0 ">
                                                <label class="active-secure-label">Proposer Email Address <span
                                                        class="any-two-red-clr">*</span></label>
                                            </div>
                                            <div class="col-lg-8 col-md-12  p-0 ">
                                                <input type="text" class="form-control textbox-style input-text-style"
                                                    formControlName="emailAddress" [(ngModel)]="emailAddress"
                                                    placeholder="Proposer Email Address">
                                            </div>
                                        </div>
                                        <div class="active-secure-body row">
                                            <div class="col-lg-4  col-md-12 p-0 ">
                                                <label class="active-secure-label">Proposer Mobile Number <span
                                                        class="any-two-red-clr">*</span></label>
                                            </div>
                                            <div class="col-lg-8 col-md-12 p-0 ">
                                                <input type="text" class="form-control textbox-style input-text-style"
                                                    minlength="10" formControlName="mobileNumber"
                                                    [(ngModel)]="mobileNumber" maxlength="10" appNumberOnly
                                                    placeholder="Proposer Mobile Number">
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="active-secure-footer ">

                                </div>
                            </ng-template>

                        </ngb-panel>

                    </ngb-accordion>
                </div>

            </div>

            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 policy-tenure-bg" [formGroup]="form" [hidden]="Ewflag">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pad-l-r-0 white-bg-box">
                    <label style="left: 0;" class="container-new">Use Health Returns of <span
                            class="checkbox-pink-txt">₹ {{HRAmount}}</span>
                        <input type="checkbox" formControlName="isActive" [(ngModel)]="isActive" [checked]="isActive"
                            (change)="updateSumInsured(isActive)" name="healthreturn">
                        <span class="checkmark"></span>
                    </label>
                </div>
                <div class="pad-l-r-0 renewal-level-main">
                    <div class="col-xs-12 col-sm-12 mb-2">
                        <a href="javascript:void(0);" class="btn download-renewal-notice-btn "
                            (click)="DownloadRenewalNotice()">
                            Download Notice
                        </a>
                    </div>
                    <div class="col-xs-12 col-sm-12 mb-2">
                        <a href="javascript:void(0);" class="btn pay-premium-button pay-premium-btn"
                            (click)="selectPaymentMode()">
                            Pay Premium <div class="d-flex"><span>₹
                                    {{totalPreminum | INR}} </span><img
                                    src="assets/images/new-renew/right-white-arrow.svg" class="ml-2"></div>
                        </a>
                    </div>
                </div>
            </div>

            <div class="pad-l-r-0 renewal-level-main" [hidden]="!Ewflag">
                <div class="col-xs-12 col-sm-12 mb-2">
                    <a href="javascript:void(0);" class="btn download-renewal-notice-btn "
                        (click)="DownloadRenewalNotice()">
                        Download Notice
                    </a>
                </div>
                <div class="col-xs-12 col-sm-12 mb-2">
                    <a href="javascript:void(0);" class="btn pay-premium-button pay-premium-btn"
                        (click)="selectPaymentMode()">
                        Pay Premium <div class="d-flex"><span>₹
                                {{totalPreminum | INR}} </span><img src="assets/images/new-renew/right-white-arrow.svg"
                                class="ml-2"></div>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <!-- End of Mobile View -->
</div>
<app-alert-swipe></app-alert-swipe>

<!--
    Page: Group Renewal Landing
	Author: Sunny Khatri & Pooja Rajput 
    Date: 10-08-2021
-->

<!------------------------------Start GHD Modal ---------------------------------->
<div id="GHD_modal" class="modal fade" [hidden]="!showGHDModal" [ngClass]="{'in': showHealthGHDModal }">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pad-l-r-0 modelSide">
                <div class="modal-header modelheading">
                    <h4 class="head">Good Health Declaration</h4>
                    <!-- <div class="close-modal align-right cursor" (click)="hideGHDModal()"><img
                                    src="assets/img/window-close.svg" /></div> -->
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pad-l-r-0 modal-body">
                    <div class="content-wrap">
                        <div class="notifi mb-20"><span>Note:</span>
                            Any Non-Disclosure or Incomplete/ incorrect/ partially correct information may lead to
                            repudiation of claim or cancellation of policy as per policy terms and condition.
                        </div>
                        <div class="DHA-modal-text mb-20">
                            <div class="DHA-text">
                                Post commencement of your insurance policy with us, did you suffer from or are currently
                                suffering from or have developed or investigated for or advised or taken medical opinion
                                or advised surgery for any disease/ illness/ injury or accident/ medical /surgical
                                condition other than common cold or viral fever?
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 p-0">
                        <div class="modal-header modelheading">
                            <h4 class="head">Insured Member(s)</h4>
                        </div>
                        <div class="DHA-modal-text" [formGroup]="GHDform">
                            <div class="scroll-div" formArrayName="GhdFormArray">
                                <div class="card" *ngFor="let member of GhdFormArray.controls; let i=index"
                                    [formGroupName]="i">
                                    <div class="row align-h-c">
                                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 card-header">
                                            <h2>{{memberDataSourceList[i].Name}}</h2>
                                        </div>
                                        <div class="col-lg-4 col-md-12 col-sm-4 col-xs-12 pad-l-r-0">
                                            <div class="prop-radio-grp">
                                                <div class="form-check form-check-inline prop-radio-flds">
                                                    <input class="form-check-input" type="radio"
                                                        [name]="'inlineRadioOptions'+i" [id]="'inlineRadio1'+i"
                                                        value="Y" (change)="gHDmemberEvent($event,i)">
                                                    <label class="form-check-label"
                                                        [attr.for]="'inlineRadio1'+i">Yes</label>
                                                </div>
                                                <div class="form-check form-check-inline prop-radio-flds">
                                                    <input class="form-check-input" type="radio"
                                                        [name]="'inlineRadioOptions'+i" [id]="'inlineRadio2'+i"
                                                        value="N" (change)="gHDmemberEvent($event,i)">
                                                    <label class="form-check-label"
                                                        [attr.for]="'inlineRadio2'+i">No</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="RmarkTextBox[i]">
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 groupText">
                                            <div class="form-group">
                                                <label for="comment">Details / Remarks</label>
                                                <textarea class="form-control" rows="3" id="comment"
                                                    placeholder="Please provide details for medical/surgical condition and duration"
                                                    formControlName="Remarks"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-20">
                                <button type="button" class="renew-btn"
                                [ngClass]="visibalSubmitButton ? 'disableButton': ''" [disabled]="visibalSubmitButton"
                                (click)="hideGHDModal()">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!------------------------------ End GHD Modal  ---------------------------------->


<!-- back TO login page modal ---------------->
<div id="backGHD_modal" class="modal fade" [hidden]="!showGHDBackModal" [ngClass]="{'in': showHealthGHDModal }">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pad-l-r-0 modelSide">
                <div class="modal-header modelheading">
                    <h4 class="head">Alert</h4>
                    <!-- <div class="close-modal align-right cursor" (click)="hideGHDModal()"><img
                                    src="assets/img/window-close.svg" /></div> -->
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pad-l-r-0 modal-body">
                    <div class="content-wrap">
                        <div class="DHA-modal-text mb-20">
                            <div class="DHA-text">
                                Sorry, your lapsed policy cannot be renewed with us. Thanks!
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 p-0">
                        <div class="DHA-modal-text">
                            <div class="mb-20">
                                <button type="button" class="renew-btn"
                                (click)="hideBackModal()">OK</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- back TO login page modal End ---------------->